import { useState } from 'react';
import { get } from 'lodash';
import { ajaxExceptionMessage } from '@skunexus/utils';

export function useRepushProduct({
    productId,
    mutation,
    successNotification = () => {},
    errorNotification = () => {},
}) {
    const [isRepushProductModalOpen, setIsRepushProductModalOpen] = useState(false);
    const [isPending, setIsPending] = useState(false);

    const handleCloseRepushProductModal = () => setIsRepushProductModalOpen(false);

    const handleOpenRepushProductModal = () => setIsRepushProductModalOpen(true);

    const handleRepushProduct = async () => {
        setIsPending(true);
        try {
            await mutation({ productId });
            successNotification('Product repushed successfully.');
            handleCloseRepushProductModal();
        } catch (error) {
            errorNotification(ajaxExceptionMessage(error));
        } finally {
            setIsPending(false);
        }
    };

    return [
        {
            repushProductModalProps: {
                headerLabel: 'Confirm Products to repush',
                isOpen: isRepushProductModalOpen,
                isLoading: isPending,
                onClose: handleCloseRepushProductModal,
                onConfirm: handleRepushProduct,
            },
        },
        { handleOpenRepushProductModal },
    ];
}
